module.exports = "/_next/static/images/Frame-f8025dfdebfa4fbe3d75af7da18b8ac9.png";